import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
import { defineComponent as _defineComponent } from 'vue';
import { useVentureId } from '~/functions/accounts';
import { AccountCategory, Module, useGetAccountQuery, useGetUserQuery } from '~/types/types';
import { isAccountAdminForAccount } from '~/functions/membership-role';
import HeaderUserMenu from '~/components/ix/HeaderUserMenu.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderVenture',
  setup: function setup(__props) {
    var route = useRoute();
    var _ref = useNuxtApp(),
      $i18n = _ref.$i18n,
      $auth = _ref.$auth;
    var ventureId = useVentureId();
    var _useGetAccountQuery = useGetAccountQuery({}, computed(function () {
        return {
          enabled: $auth.loggedIn
        };
      })),
      accountResult = _useGetAccountQuery.result;
    var portfolio = computed(function () {
      var _accountResult$value;
      return (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount;
    });
    var _useGetAccountQuery2 = useGetAccountQuery(computed(function () {
        return {
          id: ventureId.value
        };
      }), computed(function () {
        var _accountResult$value2, _accountResult$value3;
        return {
          enabled: ((_accountResult$value2 = accountResult.value) === null || _accountResult$value2 === void 0 ? void 0 : (_accountResult$value3 = _accountResult$value2.getAccount) === null || _accountResult$value3 === void 0 ? void 0 : _accountResult$value3.type) === AccountCategory.Portfolio // we should only load venture when user logged in as portfolio
        };
      })),
      result = _useGetAccountQuery2.result;
    var venture = computed(function () {
      var _accountResult$value4, _accountResult$value5, _accountResult$value6, _result$value;
      return ((_accountResult$value4 = accountResult.value) === null || _accountResult$value4 === void 0 ? void 0 : (_accountResult$value5 = _accountResult$value4.getAccount) === null || _accountResult$value5 === void 0 ? void 0 : _accountResult$value5.type) === AccountCategory.Venture ? (_accountResult$value6 = accountResult.value) === null || _accountResult$value6 === void 0 ? void 0 : _accountResult$value6.getAccount : ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getAccount) || {
        modules: [],
        portfolioLinks: []
      };
    });
    var _useGetUserQuery = useGetUserQuery(),
      userResult = _useGetUserQuery.result;
    var user = computed(function () {
      var _userResult$value;
      return (_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser;
    });
    var isAccountAdmin = computed(function () {
      return isAccountAdminForAccount(venture.value);
    });
    var showAccountUsersTab = computed(function () {
      return isAccountAdmin.value;
    });
    var canEditContextAccount = computed(function () {
      var _user$value, _accountResult$value7, _accountResult$value8;
      return Boolean((_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.isAdmin) || isAccountAdmin.value || ((_accountResult$value7 = accountResult.value) === null || _accountResult$value7 === void 0 ? void 0 : (_accountResult$value8 = _accountResult$value7.getAccount) === null || _accountResult$value8 === void 0 ? void 0 : _accountResult$value8.type) === AccountCategory.Portfolio;
    });

    // TODO please move this and merge with modules once we have a clearer ideas of module vs tabs
    var headers = computed(function () {
      var _venture$value, _venture$value$booked, _venture$value2, _venture$value2$booke, _venture$value3, _venture$value3$booke, _venture$value4, _venture$value4$booke, _venture$value5, _venture$value5$booke, _venture$value6, _venture$value6$booke, _venture$value7, _venture$value7$booke, _venture$value8, _venture$value8$booke;
      return [{
        label: $i18n.t('general.headers.modules'),
        name: 'venture-modules',
        showForModules: (_venture$value = venture.value) === null || _venture$value === void 0 ? void 0 : (_venture$value$booked = _venture$value.bookedModules) === null || _venture$value$booked === void 0 ? void 0 : _venture$value$booked.some(function (module) {
          return [Module.Esg, Module.Metrics, Module.ImpactGoal].includes(module);
        })
      }, {
        label: $i18n.t('general.headers.companyInfo'),
        name: 'venture-company',
        showForModules: (_venture$value2 = venture.value) === null || _venture$value2 === void 0 ? void 0 : (_venture$value2$booke = _venture$value2.bookedModules) === null || _venture$value2$booke === void 0 ? void 0 : _venture$value2$booke.includes(Module.CompanyInfo)
      }, {
        label: 'Users',
        name: 'venture-users',
        showForModules: showAccountUsersTab.value
      }, {
        label: $i18n.t('general.headers.esg'),
        name: 'venture-esg',
        showForModules: (_venture$value3 = venture.value) === null || _venture$value3 === void 0 ? void 0 : (_venture$value3$booke = _venture$value3.bookedModules) === null || _venture$value3$booke === void 0 ? void 0 : _venture$value3$booke.includes(Module.Esg)
      }, {
        label: $i18n.t('general.headers.impactGoal'),
        name: 'venture-impact',
        showForModules: (_venture$value4 = venture.value) === null || _venture$value4 === void 0 ? void 0 : (_venture$value4$booke = _venture$value4.bookedModules) === null || _venture$value4$booke === void 0 ? void 0 : _venture$value4$booke.includes(Module.ImpactGoal)
      }, {
        label: $i18n.t('general.headers.euTaxonomy'),
        name: 'venture-eu-taxonomy-edit-intro',
        showForModules: (_venture$value5 = venture.value) === null || _venture$value5 === void 0 ? void 0 : (_venture$value5$booke = _venture$value5.bookedModules) === null || _venture$value5$booke === void 0 ? void 0 : _venture$value5$booke.includes(Module.EuTaxonomy)
      }, {
        label: $i18n.t('general.headers.kpis'),
        name: 'venture-metrics',
        showForModules: (_venture$value6 = venture.value) === null || _venture$value6 === void 0 ? void 0 : (_venture$value6$booke = _venture$value6.bookedModules) === null || _venture$value6$booke === void 0 ? void 0 : _venture$value6$booke.includes(Module.Metrics)
      }, {
        label: $i18n.t('general.headers.csrd'),
        name: 'venture-submodule-csrd',
        link: "/csrd/valueChain",
        showForModules: (_venture$value7 = venture.value) === null || _venture$value7 === void 0 ? void 0 : (_venture$value7$booke = _venture$value7.bookedModules) === null || _venture$value7$booke === void 0 ? void 0 : _venture$value7$booke.includes(Module.Csrd) // when not in CSRD, this directly take user to value chain page
      }, {
        label: $i18n.t('general.headers.csrd'),
        icon: 'mdi-arrow-left',
        name: 'csrd-back',
        link: "/".concat(ventureId.value, "/modules"),
        showForModules: (_venture$value8 = venture.value) === null || _venture$value8 === void 0 ? void 0 : (_venture$value8$booke = _venture$value8.bookedModules) === null || _venture$value8$booke === void 0 ? void 0 : _venture$value8$booke.includes(Module.Csrd) // this is for going back to main nav when user is in csrd module
      }].concat(_toConsumableArray([
      // 'Dashboard',
      // 'Company',
      {
        folder: 'valueChain',
        label: 'ValueChain'
      }, {
        folder: 'impacts',
        label: 'Impacts'
      }, {
        folder: 'riskAndOpportunities',
        label: 'RiskAndOpportunities'
      }, {
        folder: 'stakeholders',
        label: 'Stakeholders'
      }, {
        folder: 'esrs',
        label: 'ESRS'
      }].map(function (m) {
        var _venture$value9, _venture$value9$booke;
        return {
          label: $i18n.t("general.headers.csrd".concat(m.label)),
          name: "csrd-".concat(m.folder),
          showForModules: (_venture$value9 = venture.value) === null || _venture$value9 === void 0 ? void 0 : (_venture$value9$booke = _venture$value9.bookedModules) === null || _venture$value9$booke === void 0 ? void 0 : _venture$value9$booke.includes(Module.Csrd)
        };
      }))).filter(function (header) {
        return header.showForModules;
      }).filter(function (header) {
        var _header$name;
        var name = (_header$name = header.name) !== null && _header$name !== void 0 ? _header$name : '';
        if (route.path.startsWith("/csrd")) {
          return name.startsWith('csrd');
        }
        return !name.startsWith('csrd');
      });
    });
    var tab = ref('venture-modules');
    var onInput = function onInput(v) {
      sessionStorage.setItem('ix-account-id', v);
      window.location.href = '/';
    };
    var accounts = computed(function () {
      var _user$value2;
      return user === null || user === void 0 ? void 0 : (_user$value2 = user.value) === null || _user$value2 === void 0 ? void 0 : _user$value2.accounts;
    });
    var isPortfolio = computed(function () {
      return !!(portfolio.value && portfolio.value.type === AccountCategory.Portfolio);
    });
    var showAccountSelection = computed(function () {
      var _accounts$value, _user$value3;
      return (accounts === null || accounts === void 0 ? void 0 : (_accounts$value = accounts.value) === null || _accounts$value === void 0 ? void 0 : _accounts$value.length) > 1 && !((_user$value3 = user.value) !== null && _user$value3 !== void 0 && _user$value3.isAdmin);
    });
    return {
      __sfc: true,
      route: route,
      $i18n: $i18n,
      $auth: $auth,
      ventureId: ventureId,
      accountResult: accountResult,
      portfolio: portfolio,
      result: result,
      venture: venture,
      userResult: userResult,
      user: user,
      isAccountAdmin: isAccountAdmin,
      showAccountUsersTab: showAccountUsersTab,
      canEditContextAccount: canEditContextAccount,
      headers: headers,
      tab: tab,
      onInput: onInput,
      accounts: accounts,
      isPortfolio: isPortfolio,
      showAccountSelection: showAccountSelection,
      HeaderUserMenu: HeaderUserMenu
    };
  }
});